import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    columnItem: {
        height: '56px',
    },
    categoryInfo: {
        paddingTop: '16px',
    },
}));
